var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"toast-container",attrs:{"name":"toast","tag":"div"}},_vm._l((_vm.queue),function(message){return _c('div',{key:message.id,staticClass:"toast-message"},[_vm._v(_vm._s(message.message))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }